import React from "react";
import PropTypes from "prop-types";
import styles from "components/documents/document-viewer.scss";
import { focusedDocumentType, documentPropType } from "custom-prop-types";
import { RenderedDocument } from "components/documents/documents-grid/rendered-document";

export const DocumentViewer = (props) => {
  if (props.isDocumentViewerVisible) {
    return renderDocumentViewer(props);
  }
  return null;
};

DocumentViewer.propTypes = {
  isDocumentViewerVisible: PropTypes.bool.isRequired
};

const renderDocumentViewer = (props) => {
  const draggableStyle = props.isDraggable ? styles["viewer-modal"] : "";
  if (props.focusedDocument.id && props.focusedDocument.attachment) {
    return (
      <div className={ `${styles["viewer-container"]} documents4 ${draggableStyle}` }>
        <RenderedDocument { ...props } />
      </div>
    );
  }

  if (props.isGLCodesVisible) {
    return (
      <div className={ `${styles["viewer-container"]} ${draggableStyle}` }>
        <RenderedDocument { ...props } focusedDocument={ props.documents[0] } />
      </div>
    );
  }

  return (
    <div className={ styles.placeholder }>
      <div className={ styles["placeholder-text"] }>
        <span className={ `${styles.blank} ${styles.close}` } onClick={ props.onHideDocumentViewer }>+</span>
        <h3 className={ styles.text }>Click on a document on the left <br /> and it will appear here!</h3>
      </div>
    </div>
  );
};

renderDocumentViewer.propTypes = {
  documents: PropTypes.arrayOf(documentPropType).isRequired,
  focusedDocument: focusedDocumentType.isRequired,
  isDraggable: PropTypes.bool.isRequired,
  isGLCodesVisible: PropTypes.bool.isRequired,
  onHideDocumentViewer: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/documents/documents-grid/document-viewer.jsx